import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ServerError } from '~/infra/ErrorResponse';
import ContactSupportButton from '../ContactSupportButton';
export const errorsTextsPath = 'components.managePaymentMethods';
export const getGeneralErrorText = (texts)=>/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            texts.beforeContactSupport(),
            /*#__PURE__*/ _jsx(ContactSupportButton, {}),
            texts.afterContactSupport()
        ]
    });
export function mapErrorToMessage(e, texts) {
    if (e.hasServerError(ServerError.BankTransferAccountBlocked)) {
        return texts.verificationFailed();
    } else {
        return getGeneralErrorText(texts.generalError);
    }
}
